// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_d65c78', '__Inter_Fallback_d65c78'","fontStyle":"normal"},"className":"__className_d65c78","variable":"__variable_d65c78"};